import { X, AlertCircle } from 'lucide-react';
import SimpleDataTable from './SimpleDataTable';

// Fixed-overlay popup, same backdrop/card pattern already used by
// POTracker.jsx's Add/Edit PO modal — reused here as one shared drill-down
// list for every "click a summary card, see the underlying rows" feature on
// the Supply Chain Analytics Dashboard, instead of building six near-
// identical modals.
export default function DrillDownModal({ open, onClose, title, subtitle, columns, rows, loading, error }) {
  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(43,35,64,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 22, zIndex: 200 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: 920, maxWidth: '100%', maxHeight: '86vh', display: 'flex', flexDirection: 'column', borderRadius: 20, background: '#fff', boxShadow: '0 24px 60px rgba(35,28,48,0.32)', fontFamily: "'Space Grotesk', sans-serif" }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 14, padding: '20px 24px 14px', borderBottom: '1px solid #ECE7F2' }}>
          <div>
            <div style={{ fontSize: 17, fontWeight: 600, color: '#231C30' }}>{title}</div>
            {subtitle && <div style={{ fontSize: 12, color: '#8C82A0', marginTop: 3 }}>{subtitle}</div>}
          </div>
          <button onClick={onClose} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, border: 'none', borderRadius: 10, background: '#FAF8FC', color: '#6B6379', cursor: 'pointer' }}>
            <X size={16} />
          </button>
        </div>
        <div style={{ overflow: 'auto', padding: '0 0 4px' }}>
          {loading && <div style={{ padding: 46, textAlign: 'center', color: '#8C82A0', fontSize: 14 }}>Loading…</div>}
          {!loading && error && (
            <div style={{ margin: 20, background: '#F7E5EA', color: '#C25E77', borderRadius: 10, padding: '12px 16px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
              <AlertCircle size={16} /> {error}
            </div>
          )}
          {!loading && !error && <SimpleDataTable columns={columns} rows={rows} />}
        </div>
        {!loading && !error && (
          <div style={{ padding: '10px 24px', borderTop: '1px solid #ECE7F2', fontSize: 11.5, color: '#8C82A0' }}>{rows.length} row{rows.length === 1 ? '' : 's'}</div>
        )}
      </div>
    </div>
  );
}
